import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Component, Inject, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-charging-details-dialog.component',
  templateUrl: './add-charging-details-dialog.component.html',
  styleUrls: ['./add-charging-details-dialog.component.scss'],
})
export class AddCharginDetailsDialogComponent {
  placeholderColumnName: string[] = [' ', '  '];
  effectiveDate: Date;
  comments: string;
  onYes = new EventEmitter();

  placeHolderColumns = [
    { colNo: '0', colName: '' },
    { colNo: '1', colName: '' },
  ];

  laborChargingVersion1ColumnNames = [
    { colNo: '0', colName: 'ARF #' },
    { colNo: '1', colName: 'PaTI ID - TASK' },
    { colNo: '2', colName: 'Subtask BUILD' },
    { colNo: '3', colName: 'Subtask USRXP' },
    { colNo: '4', colName: 'Subtask DATA' },
    { colNo: '5', colName: 'Subtask Innovate' }
  ];

  laborChargingVersion2ColumnNames = [
    { colNo: '0', colName: 'ARF #' },
    { colNo: '1', colName: 'PaTI ID - TASK' },
    { colNo: '2', colName: 'Subtask CAPITAL' },
    { colNo: '3', colName: 'Subtask O&M' }
  ]

  expensesPurchasesVersion1ColumnNames = [
    { colNo: '0', colName: 'Project ID' },
    { colNo: '1', colName: 'Business Unit' },
    { colNo: '2', colName: 'Oper Unit' },
    { colNo: '3', colName: 'Activity' },
    { colNo: '4', colName: 'Activity' },
    { colNo: '5', colName: 'Activity' },
    { colNo: '6', colName: 'Activity' },
    { colNo: '7', colName: '% Distn' }
  ];

  expensesPurchasesVersion2ColumnNames = [
    { colNo: '0', colName: 'Project ID' },
    { colNo: '1', colName: 'Business Unit' },
    { colNo: '2', colName: 'Oper Unit' },
    { colNo: '3', colName: 'Percentage' },
    { colNo: '4', colName: 'Capital Activity' },
    { colNo: '5', colName: 'O&M Activity' }
  ];

  expensesPurchasesVersion3ColumnNames = [
    { colNo: '0', colName: 'Project ID' },
    { colNo: '1', colName: 'Business Unit' },
    { colNo: '2', colName: 'Oper Unit' },
    { colNo: '3', colName: 'Percentage' },
    { colNo: '4', colName: 'Capital Activity' },
    { colNo: '5', colName: 'O&M Activity' },
    { colNo: '6', colName: 'Removal Activity' }
  ];

  initialTableValue = {
    tableName: '',
    columns: [...this.placeHolderColumns],
    tableData: [[]],
  };

  tables: {
    tableName: string;
    columns: { colNo: string; colName: string }[];
    tableData: string[][];
  }[] = [{ ...this.initialTableValue }];

  duplicates: { [key: number]: number[] } = {};

  constructor(
    public dialogRef: MatDialogRef<AddCharginDetailsDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (data.tables) {
      this.tables = JSON.parse(JSON.stringify(data.tables));
      if (data.approvedAfterJointOwner) {
        let tableIndex = -1;
        for (let j = 0; j < this.tables.length; j++) {
          if (this.tables[j].tableName === 'For expenses and purchases:') {
            tableIndex = j;
          }
        }
        for (let i = 0; i < data.itProjects.length; i++) {
          if (data.itProjectClassification['ets_proj_classification'] === 'Lighthouse') {
            if (data.catawbaOperatingUnits.includes(data.itProjects[i].operatingUnit)) {
              if (tableIndex !== -1) {
                this.tables[tableIndex].tableData.push([data.itProjects[i].projectID, data.itProjects[i].businessUnit, data.itProjects[i].operatingUnit,
                  'BUILD', 'USRXP', 'DATA', 'INNOVATE', data.itProjects[i].fundingProjectPercent]);
              }
            }
          }
          else {
            if (data.catawbaOperatingUnits.includes(data.itProjects[i].operatingUnit)) {
              let capitalValue = '';
              let omValue = '';
              let removalValue = '';
              for (let j = 0; j < data.itProjects[i].activities.length; j++) {
                if (data.itProjects[i].activities[j].activity === 'CAP') {
                  capitalValue = 'CAP';
                }
                if (data.itProjects[i].activities[j].activity === 'OM') {
                  omValue = 'OM';
                }
                if (data.itProjects[i].activities[j].activity === 'R') {
                  removalValue = 'R';
                }
              }
              if (tableIndex !== -1) {
                if (this.projectHasRemoval()) {
                  this.tables[tableIndex].tableData.push([data.itProjects[i].projectID, data.itProjects[i].businessUnit, data.itProjects[i].operatingUnit, data.itProjects[i].fundingProjectPercent, 
                    capitalValue, omValue, removalValue]);
                }
                else {
                  this.tables[tableIndex].tableData.push([data.itProjects[i].projectID, data.itProjects[i].businessUnit, data.itProjects[i].operatingUnit, data.itProjects[i].fundingProjectPercent, 
                    capitalValue, omValue]);
                }
              }
            }
          }
        }
        // Reset all percentages to originals from itProjects
        if (tableIndex !== -1) {
          let pctIndex = data.itProjectClassification['ets_proj_classification'] === 'Lighthouse' ? 7 : 3;
          for (let row = 0; row < this.tables[tableIndex].tableData.length; row++) {
            let projectID = this.tables[tableIndex].tableData[row][0];
            for (let p = 0; p < data.itProjects.length; p++) {
              if (data.itProjects[p].projectID === projectID) {
                this.tables[tableIndex].tableData[row][pctIndex] = data.itProjects[p].fundingProjectPercent;
                break;
              }
            }
          }
        }
      }
    } else {
      let tableData = [];
      for (let i = 0; i < data.itProjects.length; i++) {
        if (data.itProjectClassification['ets_proj_classification'] === 'Lighthouse') {
          if ((data.isCompletion && !data.rejectedByJointOwner) || !data.catawbaOperatingUnits.includes(data.itProjects[i].operatingUnit)) {
            tableData.push([data.itProjects[i].projectID, data.itProjects[i].businessUnit, data.itProjects[i].operatingUnit,
              'BUILD', 'USRXP', 'DATA', 'INNOVATE', data.itProjects[i].fundingProjectPercent]);
          }
        }
        else {
          let capitalValue = '';
          let omValue = '';
          let removalValue = '';
          for (let j = 0; j < data.itProjects[i].activities.length; j++) {
            if (data.itProjects[i].activities[j].activity === 'CAP') {
              capitalValue = 'CAP';
            }
            if (data.itProjects[i].activities[j].activity === 'OM') {
              omValue = 'OM';
            }
            if (data.itProjects[i].activities[j].activity === 'R') {
              removalValue = 'R';
            }
           }
          if (this.projectHasRemoval()) {
            if ((data.isCompletion && !data.rejectedByJointOwner) || !data.catawbaOperatingUnits.includes(data.itProjects[i].operatingUnit)) {
              tableData.push([data.itProjects[i].projectID, data.itProjects[i].businessUnit, data.itProjects[i].operatingUnit, data.itProjects[i].fundingProjectPercent, 
                capitalValue, omValue, removalValue]);
            }
          }
          else {
            if ((data.isCompletion && !data.rejectedByJointOwner) || !data.catawbaOperatingUnits.includes(data.itProjects[i].operatingUnit)) {
              tableData.push([data.itProjects[i].projectID, data.itProjects[i].businessUnit, data.itProjects[i].operatingUnit, data.itProjects[i].fundingProjectPercent, 
                capitalValue, omValue]);
            }
          }
        }
      }
      // Inflate non-Catawba percentages to total 100% when Catawba projects are excluded
      if (!data.isCompletion || data.rejectedByJointOwner) {
        let hasCatawbaExcluded = false;
        for (let i = 0; i < data.itProjects.length; i++) {
          if (data.catawbaOperatingUnits.includes(data.itProjects[i].operatingUnit)) {
            hasCatawbaExcluded = true;
            break;
          }
        }
        if (hasCatawbaExcluded && tableData.length > 0) {
          let pctIndex = data.itProjectClassification['ets_proj_classification'] === 'Lighthouse' ? 7 : 3;
          let total = 0;
          for (let i = 0; i < tableData.length; i++) {
            total += parseFloat(tableData[i][pctIndex]) || 0;
          }
          if (total > 0 && total < 100) {
            let inflated = [];
            let largestIndex = 0;
            let largestValue = 0;
            for (let i = 0; i < tableData.length; i++) {
              let originalPct = parseFloat(tableData[i][pctIndex]) || 0;
              let newPct = Math.round((originalPct / total) * 100 * 100) / 100;
              inflated.push(newPct);
              if (newPct > largestValue) {
                largestValue = newPct;
                largestIndex = i;
              }
            }
            let inflatedSum = Math.round(inflated.reduce((sum, val) => sum + val, 0) * 100) / 100;
            let diff = Math.round((100 - inflatedSum) * 100) / 100;
            if (diff !== 0) {
              inflated[largestIndex] = Math.round((inflated[largestIndex] + diff) * 100) / 100;
            }
            for (let i = 0; i < tableData.length; i++) {
              tableData[i][pctIndex] = inflated[i];
            }
          }
        }
      }
      let expenseColumns;
      if (data.itProjectClassification['ets_proj_classification'] === 'Lighthouse') {
        expenseColumns = this.expensesPurchasesVersion1ColumnNames;
      }
      else {
        if (this.projectHasRemoval()) {
          expenseColumns = this.expensesPurchasesVersion3ColumnNames;
        }
        else {
          expenseColumns = this.expensesPurchasesVersion2ColumnNames;
        }
      }
      this.tables = [{
        tableName: 'In PaTI and MyTime - For Labor Charging:',
        columns: data.itProjectClassification['ets_proj_classification'] === 'Lighthouse' ? this.laborChargingVersion1ColumnNames : this.laborChargingVersion2ColumnNames,
        tableData: [[data.formNumber]],
      },
      {
        tableName: 'For expenses and purchases:',
        columns: expenseColumns,
        tableData: tableData,
      }];
    }

    if (data.effectiveDate) {
      this.effectiveDate = JSON.parse(JSON.stringify(data.effectiveDate));
    }
  }

  projectHasRemoval() {
    for (let i = 0; i < this.data.itProjects.length; i++) {
      for (let j = 0; j < this.data.itProjects[i].activities.length; j++) {
        if (this.data.itProjects[i].activities[j].activity === 'R') {
          return true;
        }
      }
    }
    return false;
  }

  getColumnDefs(tableIndex: number) {
    return [...this.tables[tableIndex].columns.map(c => c.colNo)];
  }

  onTableNameChange(event: any, tableIndex: number) {
    this.tables[tableIndex] = {
      ...this.tables[tableIndex],
      tableName: event.target.value.trim(),
    };
  }

  onColumnNameChange(event: any, tableIndex: number, columnIndex: number) {
    const table = JSON.parse(JSON.stringify(this.tables[tableIndex]));
    const columns = [...table.columns];

    const newColumnName = event.target.value.trim()

    const updatedColumns = columns.map((obj, index) => {
      if (index === columnIndex) {
        obj.colName = newColumnName;
      }
      return obj;
    });

    // Check for duplicate column names
    // this.duplicates[tableIndex] = [];
    // updatedColumns.forEach((col, index) => {
    //   const hasDuplicate = updatedColumns.some((c, i) => col.colName === c.colName && index !== i)
    //   if (hasDuplicate) this.duplicates[tableIndex].push(index)
    // });

    this.tables[tableIndex] = {
      ...table,
      columns: [...updatedColumns],
    };
  }

  onRowValueChage(
    event: any,
    tableIndex: number,
    rowIndex: number,
    columnIndex: number
  ) {
    const table = JSON.parse(JSON.stringify(this.tables[tableIndex]));
    const updatedTableData = table.tableData.map((arr, index) => {
      if (index === rowIndex) {
        arr[columnIndex] = event.target.value.trim();
      }
      return arr;
    });

    this.tables[tableIndex] = {
      ...table,
      tableData: [...updatedTableData],
    };
  }

  getRowValue(tableIndex: number, rowIndex: number, columnIndex: number) {
    if (this.tables[tableIndex].tableData[rowIndex][columnIndex])
      return this.tables[tableIndex].tableData[rowIndex][columnIndex];
    return '';
  }

  isDuplicate(tableIndex, columnIndex) {
    if (!this.duplicates[tableIndex]) return false;
    return this.duplicates[tableIndex].includes(columnIndex)
  }

  addTable() {
    this.tables = [...this.tables, { ...this.initialTableValue }];
  }

  addColumn(tableIndex: number) {
    const colNo = this.tables[tableIndex].columns.length.toString();

    this.tables[tableIndex] = {
      ...this.tables[tableIndex],
      columns: [...this.tables[tableIndex].columns, { colNo, colName: '' }],
    };
  }

  addRow(tableIndex: number) {
    this.tables[tableIndex] = {
      ...this.tables[tableIndex],
      tableData: [...this.tables[tableIndex].tableData, []],
    };
  }

  createTableData() {
    const tableData = this.tables.map(table => {
      const tableEntries = [];
      table.columns.forEach((column, columnIndex) => {
        const columnEntries = [];
        table.tableData.forEach(row => {
          if (row[columnIndex]) {
            columnEntries.push(row[columnIndex]);
          }
        });
        tableEntries.push({
          [column.colName]: columnEntries,
        });
      });
      return {
        tableName: table.tableName,
        tableEntries,
      };
    });

    return tableData;
  }

  onSave() {
    let dataStructure = {
      tableData: this.createTableData(),
      tables: this.tables,
      effectiveDate: this.effectiveDate,
      comments: this.comments
    }
    this.onYes.emit(dataStructure);
    this.closeDialog();
  }

  onCancel() {
    this.closeDialog();
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
